import React, { useState } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import listasSlice, {
  crearListaDeUsuario,
  agregarQuitarProductoALista,
} from "../redux/data/listas";

const PopUpAgregarALista = () => {
  const dispatch = useDispatch();
  /* me traigo la visibilidad del popup de las listas desde el state*/
  const visibilidadPopUpListas = useSelector(
    (state) => state.listas.visibilidadPopUpListas
  );
  const listasUsuario = useSelector((state) => state.listas.listasDeUsuario);
  const productoAModificarEnListas = useSelector(
    (state) => state.listas.productoAModificarEnListas
  );
  const listaSelecciondaId = useSelector(
    (state) => state.listas.listaSeleccionadaId
  );

  /* me traigo la accion que oculta el popup de las listas desde el state */
  const { ocultarPopUpListas, cambiarListaSeleccionada } = listasSlice.actions;

  /*state con la visibilidad general del formulario*/
  const [productoGuardadoEnLista, setproductoGuardadoEnLista] = useState(null);

  /*state para controlar el form que pide el nombre de una nueva lista */
  const [visibilidadFormCrearNuevaLista, setVisibilidadFormCrearNuevaLista] =
    useState(true);

  /*titulo de nueva lista*/
  const [tituloDeNuevaLista, setTituloDeNuevaLista] = useState("");

  //esta funcion maneja los mensajes de respuesta sobre las acciones de agregar a las lista
  const handleAgregarALista = (response) => {
    setproductoGuardadoEnLista(response);
    if (response.agregadoALista === 1) {
      //esto pasa cuando el articulo se agrego correctamente a la lista
      setTimeout(() => {
        setproductoGuardadoEnLista(null);
        dispatch(ocultarPopUpListas());
      }, 2000);
    }
  };

  return (
    visibilidadPopUpListas && (
      <PopupUnderlay onClick={() => dispatch(ocultarPopUpListas())}>
        <Popup onClick={(e) => e.stopPropagation()}>
          <h3>Agregar a una lista</h3>
          <PopUpBody>
            {/* si el usuario tiene 1 o mas listas se las mostramos*/}
            {listasUsuario && listasUsuario.length > 0 ? (
              <div>
                <h4>Tus listas</h4>
                <PopUpForm>
                  <select
                    defaultValue={listaSelecciondaId}
                    name="listas-usuario"
                    id="listas-usuario"
                    onChange={(e) => {
                      setproductoGuardadoEnLista(null);
                      if (parseInt(e.target.value) === 0) {
                        setVisibilidadFormCrearNuevaLista(true);
                      } else {
                        setVisibilidadFormCrearNuevaLista(false);
                      }
                      dispatch(
                        cambiarListaSeleccionada(parseInt(e.target.value))
                      );
                    }}
                  >
                    <option
                      value={0}
                      onClick={() => setVisibilidadFormCrearNuevaLista(true)}
                    >
                      Crear una nueva lista
                    </option>
                    {listasUsuario.map((lista) => (
                      <option key={lista.id} value={lista.id}>
                        {lista.titulo}
                      </option>
                    ))}
                  </select>
                </PopUpForm>
              </div>
            ) : null}
            {listasUsuario && listasUsuario.length === 0 || visibilidadFormCrearNuevaLista ? (
              <div>
                <h4>Nombre de lista</h4>
                <PopUpForm>
                  <input
                    type="text"
                    onChange={(e) => setTituloDeNuevaLista(e.target.value)}
                  />
                </PopUpForm>
                <p>
                  Usa las lista para organizar tus productos como quieras. Todas
                  tus listas son privadas hasta que las vuelvas públicas.
                </p>
              </div>
            ): null}

            {productoGuardadoEnLista &&
              productoGuardadoEnLista.agregadoALista === 1 && (
                <AvisoAgreadoALista>
                  <b>{`Agregamos ${productoGuardadoEnLista.producto.titulo} a tu lista`}</b>
                </AvisoAgreadoALista>
              )}

            {productoGuardadoEnLista &&
              productoGuardadoEnLista.agregadoALista === 0 && (
                <AvisoYaExisteEnLista>
                  Este producto ya existe en esta lista
                </AvisoYaExisteEnLista>
              )}
          </PopUpBody>

          <PopUpOptions>
            <button
              className="boton-cancelar"
              onClick={() => {
                dispatch(ocultarPopUpListas());
              }}
            >
              Cancelar
            </button>

            {productoGuardadoEnLista &&
            productoGuardadoEnLista.agregadoALista === 1 ? (
              <div>Guardado</div>
            ) : (
              <button
                className="boton-guardar"
                onClick={() =>
                  visibilidadFormCrearNuevaLista
                    ? dispatch(
                        crearListaDeUsuario({
                          titulo: tituloDeNuevaLista,
                          es_publica: 0,
                        })
                      ).then(({ payload }) =>
                      dispatch(
                          agregarQuitarProductoALista({
                            lista_id: payload.listaId,
                            producto_id: productoAModificarEnListas,
                          })
                        ).then(({ payload }) => {
                          handleAgregarALista(payload);
                          setTituloDeNuevaLista("");
                        })
                      )
                    : dispatch(
                        agregarQuitarProductoALista({
                          lista_id: listaSelecciondaId,
                          producto_id: productoAModificarEnListas,
                        })
                      ).then(({ payload }) => {
                        handleAgregarALista(payload);
                        setTituloDeNuevaLista("");
                      })
                }
              >
                Guardar
              </button>
            )}
          </PopUpOptions>
        </Popup>
      </PopupUnderlay>
    )
  );
};

const PopupUnderlay = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  width: 100%;
  height: 100vh;
  z-index: 4;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Popup = styled.div`
  background-color: white;
  border-radius: ${(props) => props.theme.generalBorderRadius};
  width: 300px;
  h3 {
    font-size: 16px;
    text-align: center;
    padding: 15px;
    margin-bottom: 10px;
    color: ${(props) => props.theme.primarioHover};
    border-bottom: thin solid #eee;
  }
  h4 {
    font-size: 14px;
    color: ${(props) => props.theme.primarioHover};
    margin-bottom: 10px;
  }
`;

const PopUpBody = styled.div`
  padding: 0 20px;
  div > p {
    font-size: 10px;
  }
`;

const PopUpForm = styled.div`
  margin-bottom: 10px;
  select,
  input {
    width: 100%;
    height: 35px;
    border: thin solid ${(props) => props.theme.primarioHover};
    background-color: white;
    box-sizing: border-box;
  }
  input {
    text-indent: 10px;
  }
`;

const AvisoAgreadoALista = styled.div`
  color: ${({ theme }) => theme.go};
  font-size: 14px;
  background-color: ${({ theme }) => theme.goClaro};
  padding: 5px;
  border-radius: 3px;
`;
const AvisoYaExisteEnLista = styled.div`
  color: ${({ theme }) => theme.stop};
  font-size: 14px;
  background-color: ${({ theme }) => theme.stopClaro};
  padding: 5px;
  border-radius: 3px;
`;

const PopUpOptions = styled.div`
  margin-top: 20px;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top: thin solid #eee;
  .boton-cancelar {
    border: 0;
    background-color: white;
    color: gray;
    padding: 10px;
    border-radius: ${(props) => props.theme.generalBorderRadius};
    &:hover {
      cursor: pointer;
      background-color: #eee;
    }
  }
  .boton-guardar {
    border: 0;
    color: white;
    background-color: ${(props) => props.theme.primarioHover};
    padding: 10px;
    border-radius: ${(props) => props.theme.generalBorderRadius};
    &:hover {
      cursor: pointer;
      background-color: ${(props) => props.theme.primario};
    }
  }
`;

export default PopUpAgregarALista;
